// extracted by mini-css-extract-plugin
export default {"transactionHistory":"transactionHistory_transactionHistory__BcSm1"};